/**
 * Shared presentational helpers for the admin Users panel.
 */
import React from "react";

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const SourcePill = ({ source }) => {
  const map = {
    env: "bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-100",
    runtime: "bg-[#F4EEFD] text-[#7737F6] border border-[#7737F6]/30",
    suspended: "bg-amber-100 text-amber-800 border border-amber-300",
  };
  return (
    <span className={`inline-block ${map[source] || map.runtime} text-[10.5px] font-semibold uppercase tracking-wide px-1.5 py-0.5`}>
      {source}
    </span>
  );
};

export const TypePill = ({ type }) => (
  <span className={`inline-block ${type === "domain" ? "bg-indigo-50 text-indigo-700 border border-indigo-200" : "bg-emerald-50 text-emerald-700 border border-emerald-200"} text-[10.5px] font-semibold uppercase tracking-wide px-1.5 py-0.5`}>
    {type}
  </span>
);
